export default defineNuxtRouteMiddleware((to: any) => {
  const hasDepositQuery = to.query.deposit;
  const hasOpenPixQuery = to.query.open === 'pix' && to.query.value;

  if (!hasDepositQuery && !hasOpenPixQuery) {
    return;
  }

  const { isAuthenticated } = storeToRefs(useAuthStore());

  if (!isAuthenticated.value) {
    const { openRegister, openLogin } = useAuth();

    if (to.query.page === 'login') {
      openLogin();
    } else {
      openRegister();
    }
  }

  const stop = watchEffect(async () => {
    if (isAuthenticated.value) {
      await sleep(1000);

      const { openDepositModal, defaultSelectedDepositMethod } = usePayments();

      if (hasOpenPixQuery) {
        const pixValue = String(to.query.value);

        if (!isNaN(Number(pixValue)) && Number(pixValue) > 0) {
          const { selectDepositMethod, setAutoSubmitDeposit } =
            useWalletStore();

          selectDepositMethod(defaultSelectedDepositMethod.value);
          setAutoSubmitDeposit(pixValue);
        }

        // Limpa os query params da URL imediatamente após consumir
        const router = useRouter();
        const { open, value, ...rest } = to.query;

        router.replace({ path: to.path, query: rest });
      }

      openDepositModal();

      await nextTick();
      stop();
    }
  });
});
